import React, { forwardRef } from 'react';
import { convertBrl, convertToFloatBr } from 'utility/generic';
import { getUsername } from 'services/auth';
import logoSrc from 'assets/logo.png';

const GOLD      = '#D4AF37';
const DARK      = '#111111';
const GOLD_LIGHT = '#f0d060';
const ROW_LINE  = 'rgba(212,175,55,0.2)';

const ComprovanteWhatsapp = forwardRef(({ client, productList, saldoDevedor }, ref) => {
  if (!client || !productList) return null;

  const itensFiltrados = (productList || []).filter((p) => p.type !== 'GIFT');
  const premios        = (productList || []).filter((p) => p.type === 'GIFT');

  let totalGeral = 0;
  let totalGeralLiquido = 0;
  itensFiltrados.forEach((product) => {
    const unit  = convertToFloatBr(product.value);
    const qty   = parseFloat(product.quantity);
    const bruto = unit * qty;
    totalGeral        += bruto;
    totalGeralLiquido += bruto - (bruto * parseFloat(client.commission || 0)) / 100;
  });

  const vendedor = getUsername ? getUsername().split(' ')[0] : '';
  const saldo    = parseFloat(saldoDevedor) || 0;

  return (
    <div
      ref={ref}
      style={{
        width: '480px',
        background: DARK,
        color: GOLD,
        fontFamily: "'Arial', sans-serif",
        padding: '28px 24px',
        boxSizing: 'border-box',
      }}
    >
      {/* Cabeçalho */}
      <div style={{ textAlign: 'center', marginBottom: '16px' }}>
        <img
          src={logoSrc}
          alt='DNG Entretenimento'
          crossOrigin='anonymous'
          style={{ width: '100px', height: '100px', objectFit: 'contain', marginBottom: '6px' }}
        />
        <div style={{ fontSize: '20px', fontWeight: 'bold', color: GOLD, letterSpacing: '2px' }}>
          DNG ENTRETENIMENTO
        </div>
        <div style={{ fontSize: '12px', color: GOLD_LIGHT, marginTop: '2px' }}>
          — COMPROVANTE DE PRÉ-VENDA —
        </div>
      </div>

      <Divider />

      {/* Dados do cliente (negrito) */}
      <div style={{ marginBottom: '14px', fontSize: '13px', lineHeight: '1.9' }}>
        <InfoRow label='Data'     value={new Date().toLocaleDateString('pt-BR')} />
        {vendedor && <InfoRow label='Vendedor' value={vendedor} />}
        <InfoRow label='Cliente'  value={client.name  || '—'} />
        {client.city && <InfoRow label='Cidade' value={client.city} />}
        <InfoRow label='Comissão' value={`${client.commission || 0}%`} />
      </div>

      <Divider />

      {/* Tabela de produtos */}
      <div style={{ fontSize: '12px', marginBottom: '14px' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ color: GOLD_LIGHT, borderBottom: `1px solid ${GOLD}` }}>
              <Th left>PRODUTO</Th>
              <Th>QTD</Th>
              <Th>UNIT.</Th>
              <Th>TOTAL</Th>
              <Th>A PAGAR</Th>
            </tr>
          </thead>
          <tbody>
            {itensFiltrados.length === 0 ? (
              <tr>
                <td colSpan={5} style={{ color: '#ff6b6b', textAlign: 'center', padding: '10px 0' }}>
                  Nenhum produto cadastrado.
                </td>
              </tr>
            ) : (
              itensFiltrados.map((product, idx) => {
                const unit  = convertToFloatBr(product.value);
                const qty   = parseFloat(product.quantity);
                const bruto = unit * qty;
                const aPagar = bruto - (bruto * parseFloat(client.commission || 0)) / 100;
                return (
                  <tr key={idx} style={{ borderBottom: `1px solid ${ROW_LINE}`, color: '#e8d88a' }}>
                    <Td left>{product.name}</Td>
                    <Td>{product.quantity}</Td>
                    <Td>{product.value}</Td>
                    <Td>{convertBrl(bruto)}</Td>
                    <Td>{convertBrl(aPagar)}</Td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      {/* Totais */}
      <div style={{ borderTop: `1px solid ${GOLD}`, borderBottom: `1px solid ${GOLD}`, padding: '10px 0', marginBottom: '14px' }}>
        <TotalRow label='Valor Total Bruto'    value={convertBrl(totalGeral)} />
        <TotalRow label='Total a Pagar (líq.)' value={convertBrl(totalGeralLiquido)} highlight />
        <TotalRow
          label='Saldo Devedor Anterior'
          value={convertBrl(saldo)}
          color='#2dce89'
          highlight
        />
      </div>

      {/* Prêmios */}
      {premios.length > 0 && (
        <div style={{ marginBottom: '14px' }}>
          <div style={{ fontSize: '12px', fontWeight: 'bold', color: GOLD, textAlign: 'center', marginBottom: '6px', letterSpacing: '1px' }}>
            PRÊMIOS
          </div>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
            <thead>
              <tr style={{ color: GOLD_LIGHT, borderBottom: `1px solid ${GOLD}` }}>
                <Th left>PRODUTO</Th>
                <Th>QTD</Th>
              </tr>
            </thead>
            <tbody>
              {premios.map((p, idx) => (
                <tr key={idx} style={{ borderBottom: `1px solid ${ROW_LINE}`, color: '#e8d88a' }}>
                  <Td left>{p.name}</Td>
                  <Td>{p.quantity} un.</Td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Rodapé */}
      <div style={{ marginTop: '16px', textAlign: 'center', fontSize: '15px', color: GOLD_LIGHT, fontStyle: 'italic', fontWeight: 'bold' }}>
        "O senhor é meu pastor e nada me faltará." — Salmos 23:1
      </div>
    </div>
  );
});

ComprovanteWhatsapp.displayName = 'ComprovanteWhatsapp';
export default ComprovanteWhatsapp;

// --- helpers ---
function Divider() {
  return <div style={{ borderTop: `1px solid ${GOLD}`, marginBottom: '14px', opacity: 0.5 }} />;
}

function InfoRow({ label, value }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <span style={{ fontWeight: 'bold' }}>{label}:</span>
      <span style={{ fontWeight: 'bold' }}>{value}</span>
    </div>
  );
}

function Th({ children, left }) {
  return (
    <th style={{ padding: '5px 4px', textAlign: left ? 'left' : 'right', fontWeight: 'bold', fontSize: '11px', opacity: 0.85 }}>
      {children}
    </th>
  );
}

function Td({ children, left }) {
  return (
    <td style={{ padding: '5px 4px', textAlign: left ? 'left' : 'right' }}>
      {children}
    </td>
  );
}

function TotalRow({ label, value, highlight, color }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: highlight ? '14px' : '13px', fontWeight: highlight ? 'bold' : 'normal', color: color || (highlight ? GOLD_LIGHT : GOLD), marginBottom: '4px' }}>
      <span>{label}</span>
      <span>{value}</span>
    </div>
  );
}
